export default __webpack_public_path__ + "static/media/Firewalls-ICON.17df4229.png";